const styles = theme => ({
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
  },
  btn: {
    width: 'auto',
    minWidth: '105px',
    height: 'auto',
    // background: theme.palette.primary.white,
    color: theme.palette.secondary.dim,
    padding: '12px',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '21.6px',
    textTransform: 'none',
    border: '0',
    margin: '0',
    borderRadius: '0px',
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      flex: '1',
    },
    '&:hover': {
      // backgroundColor: '#fff',
    },
  },
  active: {
    color: '#0D2A3A',
    fontWeight: '700',
    lineHeight: '24px',
    borderBottom: '3px solid #0088FF',
    // backgroundColor: '#fff',
    '&:hover': {
      color: '#0D2A3A',
      // backgroundColor: '#fff',
    },
  },
});

export default styles;
